module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"de":{"Preferences":"Einstellungen","Share Meal Planner":"Meal Planner teilen","I\u0027m using this to plan my shopping.":"Damit plane ich meine Einkäufe."}}')
  delete Component.options._Ctor
}
